// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// imports
import { Icon } from './icon.component';

// exports
export {
  Icon,
};

@NgModule({
  declarations: [
    Icon,
  ],
  exports: [
    Icon,
  ],
  imports: [
    CommonModule,
  ]
})
export class IconModule { }
